<script setup>
import { useForm } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const props = defineProps({ vehicle: { type: Object, required: true } })
const emit  = defineEmits(['close'])
const { t } = useI18n()

const form = useForm({ description: '', planned_end_date: '' })

function submit() {
  form.transform(d => ({ maintenance_log: d })).post(
    `/vehicles/${props.vehicle.id}/maintenance_logs`,
    { preserveScroll: true, onSuccess: () => emit('close') }
  )
}
</script>

<template>
  <div class="overlay" @click.self="emit('close')">
    <div class="modal">
      <header class="modal__hdr">
        <h2>{{ t('supplier_portal.maintenance.put_title') }}</h2>
        <button class="modal__x" @click="emit('close')">×</button>
      </header>
      <form @submit.prevent="submit" class="form">
        <label>{{ t('supplier_portal.maintenance.description') }}
          <textarea v-model="form.description" rows="3" required></textarea>
        </label>
        <label>{{ t('supplier_portal.maintenance.planned_end') }}
          <input type="date" v-model="form.planned_end_date" />
        </label>
        <p class="hint">{{ t('supplier_portal.maintenance.put_hint') }}</p>
        <div class="actions">
          <button type="button" class="btn" @click="emit('close')">{{ t('supplier_portal.maintenance.cancel') }}</button>
          <button type="submit" class="btn btn--primary" :disabled="form.processing">
            {{ form.processing ? t('supplier_portal.maintenance.put_loading') : t('supplier_portal.maintenance.put_submit') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.overlay { position: fixed; inset: 0; z-index: 60; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; padding: 1rem; }
.modal { background: var(--surface); border-radius: var(--radius-lg, 12px); padding: 1.25rem; width: 100%; max-width: 28rem; }
.modal__hdr { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; }
.modal__hdr h2 { font-size: 1rem; font-weight: 700; margin: 0; color: var(--ink); }
.modal__x { background: none; border: 0; font-size: 1.5rem; color: var(--muted); cursor: pointer; }
.form { display: grid; gap: 0.875rem; }
.form label { display: grid; gap: 0.3rem; font-size: 0.8125rem; color: var(--inkSoft); }
.form input, .form textarea { padding: 0.5rem 0.75rem; background: var(--surface); border: 1px solid var(--line); border-radius: var(--radius-input, 8px); color: var(--ink); font: inherit; }
.form input:focus, .form textarea:focus { outline: 2px solid var(--accent); outline-offset: 1px; }
.hint { margin: 0; font-size: 0.8125rem; color: var(--muted); }
.actions { display: flex; gap: 0.5rem; justify-content: flex-end; }
.btn { padding: 0.45rem 0.85rem; border: 1px solid var(--line); background: var(--surface); color: var(--ink); border-radius: var(--radius-button, 8px); cursor: pointer; font-weight: 500; }
.btn--primary { background: var(--accent); color: var(--accentInk); border-color: var(--accent); }
.btn--primary:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
